import { Context } from 'react';

export interface IPaginationStoreAction<T, P = any> {
  type: T;
  payload: P;
}

export enum PaginationActionTypes {
  SET_DISPATCH = 'PaginationStore/SET_DISPATCH',
  SET_SHOW_ALL = 'PaginationStore/SET_SHOW_ALL',
  TOGGLE_SHOW_ALL = 'PaginationStore/TOGGLE_SHOW_ALL',
}

export type PaginationDispatcher = (action: IPaginationStoreAction<PaginationActionTypes>) => void;

export interface IPaginationState {
  currPage?: number;
  showAll?: boolean;
}

export interface IPaginationStore extends IPaginationState {
  dispatch?: PaginationDispatcher;
}

// eslint-disable-next-line
export interface IPaginationProvider {}

export type PaginationReducer = (state: IPaginationStore, action: IPaginationStoreAction<PaginationActionTypes>) => IPaginationStore;

export interface IWithPaginationConfig {
  reducerFn?: (defaultReducer: PaginationReducer) => PaginationReducer;
  Context?: Context<IPaginationStore>;
}
export interface IPaginationWrapperProps {
  dispatch?: (action: IPaginationStoreAction<PaginationActionTypes>) => void;
}
